import React from 'react'
import image from "./Image/last.JPG";

function About() {
  return (
    <>
<div className="container1">
    <img className='img-2' width={'100%'} height={'900px'} src='https://www.smilefoundationindia.org/wp-content/uploads/2022/12/about.jpg'/>    
    <div className="centered text-uppercase text-light"><h1>Real Work. Real Change</h1></div>
</div>

<div class=" container-fluid p-4 text-center">
  <div class="row ">
    <div class="col-lg-4">
        <div className='row'>
            <div className='col-lg-4 rec-1 '> <h3 className='text-light'>OUR STORY</h3> </div>
            <div className='col-lg-4 rec-2'> <h3 className=' text-dark'>VISION</h3> </div>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>MISSION</h3> </div>
        </div>
    </div>
    <div class="col-lg-8">
         <div className='row'>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>PHILOSOPHY OF CHANGE</h3> </div>
            <div className='col-lg-3 rec-2'> <h3 className=' text-dark'>THE LIFECYCLE APPROACH</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>HOW WE WORK</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>WHY TRUST US?</h3> </div>
        </div>
    </div>
  </div>
 
</div>
<div className='container details1 '>
    <p>Smile Foundation was initiated in 2002 when a group of friends came together with the intention of giving back to the society. They were inspired by the thought and philosophy of Peter Senge, the founder of the Society for Organizational Learning who has propagated that “sustainability, social equality and the environment are now business problems…” and corporate leaders can’t expect governments to solve them alone.</p>
    <p>What triggered these thoughts was the liberalisation of the Indian economy in the 1990’s which brought with it immense opportunities. Business revived, and India became not just a market, but also an investment prospect for the developed world. Disposable incomes and early settlements became a living reality for the working middle-class. For the first time in India, professionals could think beyond making a living, and contribute towards the society.</p>
</div>
<div className='imga-1'></div>
<div className='container details1 '>
    <p>Fuelled with enthusiasm, Smile’s founders gave a shape to their dream, and Smile Foundation was born. Over the last two decades, Smile has evolved as a sustainable Indian social institution – committed to do real work on the ground, and make the society and businesses inclusive in the process of bringing change.</p>
    <p>On our way, we had to make many difficult choices and constantly innovate – whether it was choosing to work on the ground through a service-delivery approach, practicing management principles and adopting a business-like approach in the development sector, creating a unique resource modeling keeping businesses at the centre, or promoting the concept of civic driven change. Yes, we almost always took the road less travelled, and as they say, that has made all the difference!</p>
</div>

<div class=" container-fluid p-4 text-center">
  <div class="row ">
    <div class="col-lg-4">
        <div className='row'>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>OUR STORY</h3> </div>
            <div className='col-lg-4 rec-1'> <h3 className=' text-light'>VISION</h3> </div>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>MISSION</h3> </div>
        </div>
    </div>
    <div class="col-lg-8">
         <div className='row'>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>PHILOSOPHY OF CHANGE</h3> </div>
            <div className='col-lg-3 rec-2'> <h3 className=' text-dark'>THE LIFECYCLE APPROACH</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>HOW WE WORK</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>WHY TRUST US?</h3> </div>
        </div>
    </div>
  </div>
 
</div>
<div className='container-fluid paddingx'>
    <div className='row'>
        <div className='col-lg-4 details2 '>
            <div className='row'>
                <div className='col-lg-2 ima-1'></div>
                <div className='col-lg-10'><p>Work as a catalyst in bringing sustainable change in the lives of lesser privileged children and families with a life-cycle approach of development</p></div>
            </div>
        </div>
        <div className='col-lg-4 details2'>
            <div className='row'>
                <div className='col-lg-2 ima-2'></div>
                <div className='col-lg-10'><p>Enable the civil society across the world to engage proactively in the change process through the philosophy of civic driven change</p></div>
            </div>
        </div>
        <div className='col-lg-4 details2'>
            <div className='row'>
                <div className='col-lg-2 ima-3'></div>
                <div className='col-lg-10'><p>Adopt highest standards of governance to emerge as a leading knowledge and technology driven, innovative and scalable development institution</p></div>
            </div>
        </div>

    </div>
</div>



<div class=" container-fluid  p-4 text-center">
  <div class="row ">
    <div class="col-lg-4">
        <div className='row'>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>OUR STORY</h3> </div>
            <div className='col-lg-4 rec-2'> <h3 className=' text-dark'>VISION</h3> </div>
            <div className='col-lg-4 rec-1 '> <h3 className='text-light'>MISSION</h3> </div>
        </div>
    </div>
    <div class="col-lg-8">
         <div className='row'>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>PHILOSOPHY OF CHANGE</h3> </div>
            <div className='col-lg-3 rec-2'> <h3 className=' text-dark'>THE LIFECYCLE APPROACH</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>HOW WE WORK</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>WHY TRUST US?</h3> </div>
        </div>
    </div>
  </div>
 
</div>
<div className='container'>
    <div className='row'>
        <div className='col-lg-1 '><div className='ima-4'></div></div>
        <div className='col-lg-11'><div className='details2'>
        <p>Smile Foundation is to empower underprivileged children, youth and women through relevant education, innovative healthcare and market-focused livelihood programmes. Smile Foundation is to deploy best possible methodology and technology for achieving ideal SROI (social return on investment), to practice and promote good governance. To link business competitiveness of the corporate with social development initiatives; also to sensitize privileged children, youth and citizens in general to promote Civic Driven Change.</p>
        </div>
        </div>
    </div>
</div>
<div class=" container-fluid  p-4 text-center">
  <div class="row ">
    <div class="col-lg-4">
        <div className='row'>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>OUR STORY</h3> </div>
            <div className='col-lg-4 rec-2'> <h3 className=' text-dark'>VISION</h3> </div>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>MISSION</h3> </div>
        </div>
    </div>
    <div class="col-lg-8">
         <div className='row'>
            <div className='col-lg-3 rec-1 '> <h3 className='text-light'>PHILOSOPHY OF CHANGE</h3> </div>
            <div className='col-lg-3 rec-2'> <h3 className=' text-dark'>THE LIFECYCLE APPROACH</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>HOW WE WORK</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>WHY TRUST US?</h3> </div>
        </div>
    </div>
  </div>
 
</div>
<div className='details1'>
        <p>While our focus as a development organisation has been first and foremost to work on the ground for bringing positive change in the lives of the less privileged children and families, we have been making equal efforts to sustain this change, by sensitising and engaging the privileged masses towards their social responsibility. Not remaining restricted to the community, and with the aim of achieving sustainable development in a wider social context, Smile Foundation has adopted the principle of Civic Driven Change, making the civil society an active partner in all its welfare initiatives.</p>
        <p><a className='text-secondary'>Read More &gt;</a></p>
</div>
<div class=" container-fluid  p-4 text-center">
  <div class="row ">
    <div class="col-lg-4">
        <div className='row'>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>OUR STORY</h3> </div>
            <div className='col-lg-4 rec-2'> <h3 className=' text-dark'>VISION</h3> </div>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>MISSION</h3> </div>
        </div>
    </div>
    <div class="col-lg-8">
         <div className='row'>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>PHILOSOPHY OF CHANGE</h3> </div>
            <div className='col-lg-3 rec-1'> <h3 className=' text-light'>THE LIFECYCLE APPROACH</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>HOW WE WORK</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>WHY TRUST US?</h3> </div>
        </div>
    </div>
  </div>
 
</div>
<div className='details1'>
    <p>We believe that education is both the means as well as the end to a better life: the means because it empowers an individual to earn his/her livelihood and the end because it increases one’s awareness on a range of issues – from healthcare to appropriate social behaviour to understanding one’s rights – and in the process help him/her evolve as a better citizen. Education is the most effective tool which helps children build a strong foundation; enabling them to free themselves from the vicious cycle of ignorance, poverty and disease.</p>
</div>
<div className='container'>
    <div className='row'>
                <div className='col'> <img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2022/10/5-1-768x768.png'/></div>
                <div className='col'> <img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2022/10/4-1-768x768.png'/></div>
                <div className='col'> <img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2022/10/6-768x768.png'/></div>
                <div className='col'> <img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2022/10/7-768x768.png'/></div>
                <div className='col'> <img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2022/10/3-1-768x768.png'/></div>
    </div>
</div>
<div className="container1">
    <img className='img-2' width={'100%'} height={'700px'} src='https://www.smilefoundationindia.org/wp-content/uploads/2022/10/Untitled-4-2.png'/>    
    <div className="left  text-dark">
        <p className='text-left'>But while working on the ground, we realised that child education cannot be done in isolation, without ensuring the welfare of the whole family. Health is also a part of education. A child will not go to school if he is sick. If a child’s parents are afflicted with health problems, he might drop-out of school and start earning instead. Unless the mother is healthy and empowered, the child cannot be either. It is all interlinked. </p>

        <p className='text-left pad-1'>Our other programmes evolved as a logical progression to our education programme – be it livelihood, health or women empowerment. Today, children and education continue to remain at the centre of all we do, but through the lifecycle approach we also address the needs of the children’s families and communities.
        </p></div>
</div>
<div class=" container-fluid  p-4 text-center">
  <div class="row py-4 ">
    <div class="col-lg-4 py-4">
        <div className='row'>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>OUR STORY</h3> </div>
            <div className='col-lg-4 rec-2'> <h3 className=' text-dark'>VISION</h3> </div>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>MISSION</h3> </div>
        </div>
    </div>
    <div class="col-lg-8 py-4">
         <div className='row'>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>PHILOSOPHY OF CHANGE</h3> </div>
            <div className='col-lg-3 rec-2'> <h3 className=' text-dark'>THE LIFECYCLE APPROACH</h3> </div>
            <div className='col-lg-3 rec-1 '> <h3 className='text-light'>HOW WE WORK</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>WHY TRUST US?</h3> </div>
        </div>
    </div>
  </div>
 
</div>
<div className='container p-4'>
    <div className='row'>
        <div className='col-lg-1 '><div className='ima-5'></div></div>
        <div className='col-lg-11'><div className='bold-22'>
        <h1>Social Venture Philanthropy</h1>    
        <p>Social Venture Philanthropy (SVP) is an innovative model based on the business concept of venture capital. Under SVP, Smile Foundation identifies and implements its development projects through credible community based organizations. We also handhold and build capacities of these organizations, focusing on achieving scalability and sustainability, creating a culture of leadership and excellence and inculcating a deep sense of accountability among them.</p>
        </div>
        </div>
    </div>
</div>
<div className='container p-4'>
    <div className='row'>
        <div className='col-lg-1 '><div className='ima-6'></div></div>
        <div className='col-lg-11'><div className='bold-22'>
        <h1>Outreach</h1>    
        <p>Under Outreach model, Smile Foundation implements the development interventions directly as it requires intensive and professional engagement for a wider and sustained outcome. While working in remote rural areas, we realized that an intensive on-ground intervention is needed, which might be beyond the capacity of community based organizations and hence, we directly implement such projects, liaising with local community stakeholders for better social return on investment.</p>
        </div>
        </div>
    </div>
</div>
<div class=" container-fluid  p-4 text-center">
  <div class="row py-4 ">
    <div class="col-lg-4 py-4">
        <div className='row'>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>OUR STORY</h3> </div>
            <div className='col-lg-4 rec-2'> <h3 className=' text-dark'>VISION</h3> </div>
            <div className='col-lg-4 rec-2 '> <h3 className='text-dark'>MISSION</h3> </div>
        </div>
    </div>
    <div class="col-lg-8 py-4">
         <div className='row'>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>PHILOSOPHY OF CHANGE</h3> </div>
            <div className='col-lg-3 rec-2'> <h3 className=' text-dark'>THE LIFECYCLE APPROACH</h3> </div>
            <div className='col-lg-3 rec-2 '> <h3 className='text-dark'>HOW WE WORK</h3> </div>
            <div className='col-lg-3 rec-1 '> <h3 className='text-light'>WHY TRUST US?</h3> </div>
        </div>
    </div>
  </div>
 
</div>
<div className='details1'>
<p>Credibility and accountability have always been the bench mark for Smile Foundation and are achieved through the promotion of principles of good governance in the processes and practices. We have a four- tier audit and evaluation mechanism to ensure impact of investment and complete transparency and accountability in utilisation of funds <br/><br/><a className='text-secondary'>Read More &gt;</a></p>

</div>
<div className='bg1'>
<div className='container '>
<h1 className='bold-1 text-uppercase text-center py-4'>What Our Supporters Say</h1>  
        <div className='row py-4'>

            <div className='col-lg-4'>
                <div class="embed-responsive embed-responsive-16by9">
                <iframe width="360" height="215" src="https://www.youtube.com/embed/gSOuOY2cXl0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
            </div>
            <div className='col-lg-4'>
                <div class="embed-responsive embed-responsive-16by9">
                <iframe width="360" height="215 " src="https://www.youtube.com/embed/eRze_wZrSEE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
            </div>
            <div className='col-lg-4'>
                <div class="embed-responsive embed-responsive-16by9">
                <iframe width="360" height="215" src="https://www.youtube.com/embed/WlqQODlart0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>                </div>
            </div>
       
 
        </div>
</div>
</div>
<div className='bg2 py-4 '>
    <div className='container'>
        <h1 className='bold-1 text-uppercase text-center py-4'>Awards & Accreditations</h1>  
        
        <img className='centered' src={image} alt=''/>
        
    </div>

   
</div>
<div className='bg4'><p><a className='text-light text-centered'>View All</a></p></div>




    </>
  )
}

export default About